import store from '@/store';

export const OpEnum = {
  add: 'add'
}

export const optionMap = {
  campaign:'广告活动',
  autoTarget:'投放组',
  keyword:'关键词',
  manualTarget:'商品投放',
  asinSearch:'搜索词-ASIN',
  keywordSearch:'搜索词-关键词',
  impressions:'曝光量',
  clicks:'点击量',
  cost:'花费',
  ctr:'CTR',
  cpa:'CPA',
  adsOrders:'广告订单量',
  adsSales:'广告销售额',
  cpc:'CPC',
  cvr:'CVR',
  acos:'ACOS',
  roas:'ROAS',
  le:'<=',
  ge:'>=',
  adjustBidoriginal:'原始竞价',
  adjustBudgetoriginal:'原始预算',
  adjustBidrecommendation:'建议竞价',
  adjustBudgetrecommendation:"建议预算",
  adjustBidrecommendationOfMax:'建议竞价最大值',
  adjustBidrecommendationOfMin:'建议竞价最小值',
  targetfixed:'竞价固定',
  adjustBidfixed:'竞价固定',
  adjustBudgetfixed:'预算固定',
  directApply:'直接应用',
  percentageIncrease:'上浮%',
  percentageReduction:'下调%',
  increase:'上浮',
  reduction:'下调',
  targetgroupDefaultBid:'广告组默认竞价',
  targetcpc7d:'过去7天CPC',
  targetcpc14d:'过去14天CPC',
  targetcpc30d:'过去30天CPC',
  adjustBudget: '调整预算',
  adjustBid: '调整竞价',
  target: '添加投放',
  negativeTarget:'添加到否定投放',
  parseTarget:'暂停',
  total: '总和',
  avg: '平均值',
  exact: '精确匹配',
  phrase: '词组匹配',
  broad: '广泛匹配',
  original: '原始价格',
  recommendation: '建议价格',
  recommendationOfMax: '建议价格最大值',
  recommendationOfMin: '建议价格最小值',
  fixed: '固定值',
  groupDefaultBid: '广告组默认竞价',
  cpc7d: '过去7天CPC',
  cpc14d: '过去14天CPC',
  cpc30d: '过去30天CPC',
  error: '有错误时通知',
  complete: '执行完成时通知',
  no: '不通知',
  group: '广告组',
  placement: '广告位',
  adActivity: '广告活动',
  adGroup: '广告组',
  addRule: '新增规则',
  updateRule: '更换规则',
  updateState: '修改状态',
  enabled: '开启',
  paused: '暂停',
  archived: '删除',

}
const keywordSearchAndasinSearch = [
  {
    id: 'negativeTarget',
    text: '添加到否定投放',
  },
  {
    id: 'target',
    text: '添加到投放',
  },
]
const keywordAndKeyword = [
  {
    id: 'adjustBid',
    text: '调整竞价',
  },
  {
    id: 'parseTarget',
    text: '暂停',
  },
  {
    id: 'negativeTarget',
    text: '添加到否定投放',
  },
]
export const option = {
  stateMap: {
    enabled: '已开启',
    paused: '已关闭',
    archived: '已归档',
  },
  notifyTypeOption: [
    {
      id: 'error',
      text: '有错误时通知',
    },
    {
      id: 'complete',
      text: '执行完成时通知',
    },
    {
      id: 'no',
      text: '不通知',
    },
  ],
  executeObjectAdsTypeeOption: [
    {
      id: 'campaign',
      text: '广告活动',
    },
    {
      id: 'autoTarget',
      text: '投放组',
    },
    {
      id: 'keyword',
      text: '关键词',
    },
    {
      id: 'manualTarget',
      text: '商品投放',
    },
    {
      id: 'asinSearch',
      text: '搜索词-ASIN',
    },
    {
      id: 'keywordSearch',
      text: '搜索词-关键词',
    },
  ],

  metricOption: [
    {
      id: 'impressions',
      text: '曝光量',
    },
    {
      id: 'clicks',
      text: '点击量',
    },
    {
      id: 'cost',
      text: '花费',
    },
    {
      id: 'ctr',
      text: 'CTR',
    },
    {
      id: 'adsOrders',
      text: '广告订单量',
    },
    {
      id: 'adsSales',
      text: '广告销售额',
    },
    {
      id: 'cpc',
      text: 'CPC',
    },
    {
      id: 'cvr',
      text: 'CVR',
    },
    {
      id: 'cpa',
      text: 'CPA',
    },
    {
      id: 'acos',
      text: 'ACOS',
    },
    {
      id: 'roas',
      text: 'ROAS',
    },
  ],
  calculateTypeOption: [
    {
      id: 'total',
      text: '总和',
    },
    {
      id: 'avg',
      text: '平均值',
    },
  ],
  expOption: [
    {
      id: 'le',
      text: '小于等于',
    },
    {
      id: 'ge',
      text: '大于等于',
    },
  ],
  excludeDayOption: [
    {
      id: 1,
      text: '1',
    },
    {
      id: 3,
      text: '3',
    },
    {
      id: 7,
      text: '7',
    },
  ],
  includeDayOption: [
    {
      id: 7,
      text: '7',
    },
    {
      id: 14,
      text: '14',
    },
    {
      id: 21,
      text: '21',
    },
    {
      id: 30,
      text: '30',
    },
    {
      id: 60,
      text: '60',
    },
    {
      id: 90,
      text: '90',
    },
  ],
  executeIntervalOption: [
    {
      id: 'own',
      text: '自定义',
    },
    {
      id: 1,
      text: '每1天',
    },
    {
      id: 7,
      text: '每七天',
    },
    {
      id: 14,
      text: '每14天',
    },
    {
      id: 21,
      text: '每21天',
    },
    {
      id: 30,
      text: '每30天',
    },
  ],
  campaignOption:[
    {
      id: 'adjustBudget',
      text: '调整预算',
    },
    {
      id: 'parseTarget',
      text: '暂停',
    },
  ],
  autoTargetOption:[
    {
      id: 'adjustBid',
      text: '调整竞价',
    },
    {
      id: 'parseTarget',
      text: '暂停',
    },
  ],
  keywordOption:keywordAndKeyword,
  manualTargetOption:keywordAndKeyword,
  asinSearchOption:keywordSearchAndasinSearch,
  keywordSearchOption:keywordSearchAndasinSearch,
  adjustBudgetOption:[
    {
      id: 'original',
      text: '原始预算',
    },
    {
      id: 'recommendation',
      text: '建议预算',
    },
    {
      id: 'fixed',
      text: '固定预算',
    },
  ],
  adjustBidOption:[
    {
      id: 'original',
      text: '原始竞价',
    },
    {
      id: 'recommendation',
      text: '建议竞价',
    },
    {
      id: 'recommendationOfMax',
      text: '建议竞价最大值',
    },
    {
      id: 'recommendationOfMin',
      text: '建议竞价最小值',
    },
    {
      id: 'fixed',
      text: '固定竞价',
    },
  ],
  adjustTypeOption:[
    {
      id: 'directApply',
      text: '直接应用',
    },
    {
      id: 'percentageIncrease',
      text: '上浮百分比',
    },
    {
      id: 'percentageReduction',
      text: '下调百分比',
    },
    {
      id: 'increase',
      text: '上调固定值',
    },
    {
      id: 'reduction',
      text: '下调固定值',
    }

  ],
  targetMatchTypeOption:[
    {
      id: 'exact',
      text: '精确匹配',
    },
    {
      id: 'phrase',
      text: '词组匹配',
    },
    {
      id: 'broad',
      text: '广泛匹配',
    }
  ],
  negativeTargetMatchTypeOption:[
    {
      id: 'exact',
      text: '精确匹配',
    },
    {
      id: 'phrase',
      text: '词组匹配',
    },
  ],
  targetOption:[
    {
      id: 'groupDefaultBid',
      text: '广告组默认竞价',
    },
    {
      id: 'fixed',
      text: '固定竞价',
    },
    {
      id: 'cpc7d',
      text: '过去7天CPC',
    },
    {
      id: 'cpc14d',
      text: '过去14天CPC',
    },
    {
      id: 'cpc30d',
      text: '过去30天CPC',
    },
  ],
}

export const adjustBaseMap = {
  original: '原始预算',
  recommendation: '建议预算',
  original: '原始竞价',
  recommendation: '建议竞价',
  recommendationOfMax: '建议竞价最大值',
  recommendationOfMin: '建议竞价最小值',
}

//模板规则内容整理
export function getRuleContent(item, isShowExcludeDay=true) {
  let tip = "如果 ";
  let adsType = item.executeObjectAdsType ? optionMap[item.executeObjectAdsType] : '';     //广告对象类型
  // 数据范围
  let includeDay = item.includeDay ? ` 过去${item.includeDay}天` : ' ';     //包含天数
  let excludeDay = (item.excludeDay && item.excludeDay > 0) ? `（排除近${item.excludeDay}天）的` : '的'  //排除天数
  //新增自动规则有一个勾选显示逻辑
  if (isShowExcludeDay === false) {
    excludeDay = '';
  }
  //执行条件
  var ruleInfo = '';  
  if (item.expressionList !== null && item.expressionList.length > 0) {
      for(var i=0;i < item.expressionList.length;i++){
        var obj = item.expressionList[i];
        let metric =  optionMap[obj.metric] ?  optionMap[obj.metric] : '';
        let calculateType =  optionMap[obj.calculateType] ?  optionMap[obj.calculateType] : '';
        let exp =  optionMap[obj.exp] ?  optionMap[obj.exp] : '';
        let value = obj.value ? obj.value : '';
        let and = i > 0 ? " 且 " : '';
        let percent = '';
        if (obj.metric === 'ctr' || obj.metric === 'cvr' || obj.metric === 'acos' || obj.metric === 'roas') {
          percent = '%';
        }
        let info = and + metric + ' ' + calculateType + ' ' + exp + ' ' + value + percent;
        ruleInfo = ruleInfo + info;
      }
  }
  let strategyType =  optionMap[item.strategyType] ?  optionMap[item.strategyType] : '';   //执行操作类型
  let adjustBase =  optionMap[item.adjustBase] ?  optionMap[item.adjustBase] : '';    //调价基础
  let adjustType =  optionMap[item.adjustType] ?  optionMap[item.adjustType] : '';    //调价类型
  let adjustValue = item.adjustValue ? item.adjustValue : '-';   //调价值
  let adjustLimitValue = item.adjustLimitValue ? item.adjustLimitValue : '-'; //调价极限值
  let matchType =  optionMap[item.matchType] ?  optionMap[item.matchType] : '';  //匹配类型（关键词/否定关键词特定）
  //执行操作
  var performActionStr = '';
  if (item.strategyType === 'adjustBudget' || item.strategyType === 'adjustBid') {  //调整预算,调整竞价
      let tempStr = item.strategyType === 'adjustBudget' ? '预算' : '竞价';
      var actionStr = '';
      var baseStr = '';

      if (item.adjustBase === 'original') {
        baseStr = '原始' + tempStr;
      }else if (item.adjustBase === 'recommendation') {
        baseStr = '建议' + tempStr;
      }else if (item.adjustBase === 'fixed') {
        baseStr = '固定' + tempStr;
      }else if(item.adjustBase === 'recommendationOfMax') {
        baseStr = '建议' + tempStr + '最大值';
      }else if(item.adjustBase === 'recommendationOfMin') {
        baseStr = '建议' + tempStr + '最小值';
      }else {
        baseStr = adjustBase;
      }

      if (item.adjustType === 'directApply') { //直接应用
          if (item.adjustBase === 'original') {
            actionStr = '原始' + tempStr;
          }else if(item.adjustBase === 'recommendation') {
            actionStr = '建议' + tempStr;
          }else if(item.adjustBase === 'recommendationOfMax') {
            actionStr = '建议' + tempStr + '最大值';
          }else if(item.adjustBase === 'recommendationOfMin') {
            actionStr = '建议' + tempStr + '最小值';
          }else if(item.adjustBase === 'fixed') {
            actionStr = '固定' + tempStr;
          }else {
            actionStr = adjustBase;
          }   
      }else if (item.adjustType === 'percentageIncrease') {  //上浮%
          actionStr = baseStr + ' * (100+' + adjustValue + ')%，限定最高 ' + tempStr + '为 ' + adjustLimitValue;
      }else if (item.adjustType === 'percentageReduction') {  //下调%
          actionStr = baseStr + ' * (100-' + adjustValue + ')%，限定最低 ' + tempStr + '为 ' + adjustLimitValue;
      }else if (item.adjustType === 'increase') {  //上浮
          actionStr = baseStr + ' + ' + adjustValue + '，限定最高 ' + tempStr + '为 ' + adjustLimitValue;
      }else if (item.adjustType === 'reduction') {  //下调
          actionStr = baseStr + ' - ' + adjustValue + '，限定最低 ' + tempStr + '为 ' + adjustLimitValue;
      }else {
          actionStr = baseStr;
      }

      //固定定价
      if (item.adjustBase === 'fixed') {
        performActionStr = '则' + strategyType + '，调整后= ' + adjustValue;
      }else {
        performActionStr = '则' + strategyType + '，调整后= ' + actionStr;
      }
     

  }else if (item.strategyType === 'target') {  //添加投放
      //站点，广告组，广告活动
      let marketId = item.targetMarketId;
      const markets = store.getters.marketMap;
      let marketName = marketId ?  markets[marketId].text : '';
      let targetCampaignName =  item.targetCampaignName ? item.targetCampaignName : '-';
      let targetGroupName = item.targetGroupName ? item.targetGroupName : '-';

      var actionString = '';
      if (item.adjustType === 'directApply') { //直接应用
        actionString = adjustBase;
      }else if (item.adjustType === 'percentageIncrease') {  //上浮%
        actionString = adjustBase + ' * (100+' + adjustValue + ')%，限定最高竞价为 ' + adjustLimitValue;
      }else if (item.adjustType === 'percentageReduction') {  //下调%
        actionString = adjustBase + ' * (100-' + adjustValue + ')%，限定最低竞价为 ' + adjustLimitValue;
      }else if (item.adjustType === 'increase') {  //上浮
        actionString = adjustBase + ' + ' + adjustValue + '，限定最高竞价为 ' + adjustLimitValue;
      }else if (item.adjustType === 'reduction') {  //下调
        actionString = adjustBase + ' - ' + adjustValue + '，限定最低竞价为 ' + adjustLimitValue;
      }else {
        actionString = adjustValue;
      }

      var matching = '';
      if (item.matchType === 'exact') {
        matching = '，匹配方式：精确匹配';
      }else if (item.matchType === 'phrase') {
        matching = '，匹配方式：词组匹配';
      }else if (item.matchType === 'broad') {
        matching = '，匹配方式：广泛匹配';
      }else {
        matching = '';
      }

      if (item.adjustBase === 'fixed') {   //固定竞价
        performActionStr = '则 ' + strategyType + '，添加到 ' + marketName + ' > ' + targetCampaignName + ' > ' + targetGroupName + matching + '，竞价为 ' + adjustValue;
      }else if(item.adjustBase === 'groupDefaultBid') {  //广告组默认竞价
        performActionStr = '则 ' + strategyType + '，添加到 ' + marketName + ' > ' + targetCampaignName + ' > ' + targetGroupName + matching + '，竞价为 ' + '广告组默认竞价';
      }else {
        performActionStr = '则 ' + strategyType + '，添加到 ' + marketName + ' > ' + targetCampaignName + ' > ' + targetGroupName + matching + '，竞价为 ' + actionString;
      }
  }else if (item.strategyType === 'negativeTarget') {  //添加否定投放
      var matchingStr = '';
      if (item.matchType === 'NEGATIVE_EXACT') {
        matchingStr = '，匹配类型：否定精确';
      }else if (item.matchType === 'NEGATIVE_PHRASE') {
        matchingStr = '，匹配类型：否定词组';
      }else if (item.matchType === 'NEGATIVE_BROAD') {
        matchingStr = '，匹配类型：否定广泛';
      }else if (item.matchType === 'OTHER') {
        matchingStr = '，匹配类型：其他';
      }else {
        matchingStr = '';
      }
      performActionStr = '则 ' + strategyType + matchingStr;
  }else {  //暂停
      performActionStr = '则 ' + strategyType;
  }

  //执行频率
  let rateStr = item.executeInterval <= 1 ? '（每天执行一次）' : `（每 ${item.executeInterval} 天执行一次）`;

  if (adsType !== null) {
    return tip + adsType + includeDay + excludeDay + ruleInfo + '，' + performActionStr + rateStr;
  } else {
    return "-"
  }
}

//模板规则内容整理
export function getRuleInfo(item) {
 
  if (item !== null && item.length > 0) {
      var ruleInfo = '';  
      for(var i=0;i < item.length;i++){
        var obj = item[i];
        let metric =  optionMap[obj.metric] ?  optionMap[obj.metric] : '';
        let value = obj.value ? obj.value : '';
        let sign = obj.sign ? obj.sign : '';
        let and = i > 0 ? " 且 " : '';
        let info = and + metric + '=' + value + sign;
        ruleInfo = ruleInfo + info;
      }
      return ruleInfo;
  }else {
    return "-";
  }
 

}